import { LISTING_STATUS, DOMAIN_VERIFICATION_STATUS } from '../data/models/ApplicationAuthorization';
const getIsImpersonated = state =>
// @ts-expect-error bad typings from User, but keeping this as is for potential regressions
state.auth.user.acting_user_id;
export const getErrorFields = (err, state) => {
  const {
    responseJSON
  } = err;
  const isImpersonated = getIsImpersonated(state);
  const status = responseJSON && responseJSON.status;
  const message = responseJSON && responseJSON.message;
  const subCategory = responseJSON && responseJSON.subCategory;
  const context = responseJSON && responseJSON.context;
  return {
    status,
    message,
    errorCode: status === 'error' && isImpersonated ? 'IMPERSONATION_UNAUTHORIZED' : status,
    context,
    subCategory: status === 'error' && isImpersonated ? 'errors.IMPERSONATION_UNAUTHORIZED' : subCategory
  };
};
export const getDomainVerificationStatus = providerInfo => {
  if (!(providerInfo !== null && providerInfo !== void 0 && providerInfo.domain)) {
    return DOMAIN_VERIFICATION_STATUS.NO_DOMAIN;
  }
  if (providerInfo.isVerified) {
    return DOMAIN_VERIFICATION_STATUS.VERIFIED_DOMAIN;
  }
  return DOMAIN_VERIFICATION_STATUS.UNVERIFIED_DOMAIN;
};
export const getListingStatus = listingInfo => {
  if (listingInfo !== null && listingInfo !== void 0 && listingInfo.isCertified) {
    return LISTING_STATUS.CERTIFIED;
  }
  if (listingInfo !== null && listingInfo !== void 0 && listingInfo.isPublished) {
    return LISTING_STATUS.PUBLISHED;
  }
  return LISTING_STATUS.UNLISTED;
};